import { nextTick } from "vue";
export default defineNuxtPlugin(nuxtApp => {
  const isMobile = useState("isMobile");
  const mobileMediaQuery = window.matchMedia("(max-width: 599px)");
  const updateDevice = () => {
    const newValue = mobileMediaQuery.matches;
    if (isMobile.value !== newValue) {
      isMobile.value = newValue;
    }
  };

  // Do not sync matchMedia during plugin init — that races SSR HTML (UA-based)
  // and causes "Hydration completed but contains mismatches".
  nuxtApp.hook("app:mounted", () => {
    nextTick(() => {
      updateDevice();
      mobileMediaQuery.addEventListener("change", updateDevice);
    });
  });
});